<div class="card shadow-none">
    <div class="card-body p-3">
        <div class="row">
            <div class="col-md-auto">
                <label class="grey-label">Dung lượng đã sử dụng</label><br>
            </div>
            <!-- <div class="col-md-auto ml-auto">
                <ng-select [formControl]="yearForm" [items]="years" bindLabel="label" bindValue="value"
                    [clearable]="false" [searchable]="false" class="ng-select-year">
                    <ng-template ng-label-tmp let-item="item">
                        <span class="year-label"> {{ item.label }}</span>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <span class="year-label"> {{ item.label }}</span>
                    </ng-template>
                </ng-select>
            </div> -->
        </div>
        <div>
            <google-chart #chart [type]="type" [data]="data" [options]="options" style="width: 100%; height: 150%;"
            [dynamicResize]="dynamicResize" [columns]="columnNames">
            </google-chart>
        </div>
        <div>
            
        </div>
    </div>
</div>
